import { render } from "./ArticlePage.vue?vue&type=template&id=54f2ba82&scoped=true"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"

import "./ArticlePage.vue?vue&type=style&index=0&id=54f2ba82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2ba82"]])

export default __exports__